import { InviteDriversModal } from "./modals/InviteDriversModal";
import { useDriversContext } from "./context";

export const DriversModals = () => {
  const { step, setStep } = useDriversContext();

  return (
    <>
      <InviteDriversModal
        open={step === "invite"}
        onClose={() => setStep(undefined)}
      />
    </>
  );
};